(function () {
  var RULER_ICON = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><line x1="2" y1="12" x2="22" y2="12"/><polyline points="7 8 2 12 7 16"/><polyline points="17 8 22 12 17 16"/></svg>';
  var CART_ICON = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>';

  function injectOverlays() {
    document.querySelectorAll('.product-grid .grid__item').forEach(function (item) {
      var cardInner = item.querySelector('.card__inner');
      if (!cardInner || cardInner.querySelector('.si-card-overlays')) return;

      var sizeVal = item.getAttribute('data-si-size');
      if (!sizeVal) sizeVal = '';

      var overlay = document.createElement('div');
      overlay.className = 'si-card-overlays';

      if (sizeVal) {
        var badge = document.createElement('span');
        badge.className = 'si-size-badge';
        badge.innerHTML = RULER_ICON + '<span>' + sizeVal + '</span>';
        overlay.appendChild(badge);
      }

      var quickAddSubmit = item.querySelector('.quick-add__submit');
      var productLink = item.querySelector('.card__heading a');

      if (quickAddSubmit) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'si-quick-cart-btn';
        btn.setAttribute('aria-label', 'Add to cart');
        btn.innerHTML = CART_ICON;
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var form = item.querySelector('form[id^="quick-add-"]');
          if (form) {
            // Use requestSubmit so event.submitter is set correctly for Dawn's product-form
            try {
              form.requestSubmit(quickAddSubmit);
            } catch (err) {
              quickAddSubmit.click();
            }
          } else {
            // Multi-variant: click opens the quick-add modal
            quickAddSubmit.click();
          }
        });
        overlay.appendChild(btn);
      } else if (productLink) {
        var a = document.createElement('a');
        a.href = productLink.href;
        a.className = 'si-quick-cart-btn';
        a.setAttribute('aria-label', 'View options');
        a.innerHTML = CART_ICON;
        overlay.appendChild(a);
      }

      cardInner.appendChild(overlay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectOverlays);
  } else {
    injectOverlays();
  }
})();
